import { useNavigate } from 'react-router-dom';

import { ActionStickerCard, ImageCard, BaseNugget } from '@backrs_ui/common-ui';

import { LubavTool } from '@backrs_ui/grow-ui/src/models/models';
import {
  useToolCardById,
  StickerCardId,
  ImageCardId,
} from '@backrs_ui/grow-ui/src/pages/Home/hooks/stickerCardMapping';

import { Box, Theme, SxProps } from '@mui/material';

type ToolNuggetProps = Readonly<{
  tool: LubavTool;
}>;

export const ToolNugget = ({ tool }: ToolNuggetProps) => {
  const navigate = useNavigate();
  const { getStickerCard, getImageCard } = useToolCardById({ navigate });

  const stickerCard = getStickerCard(tool.id as StickerCardId);
  const imageCard = getImageCard(tool.id as ImageCardId);

  if (!stickerCard && !imageCard) return null;

  return (
    <BaseNugget subText={tool.relevance} fitContent>
      <Box sx={contentContainerStyle}>
        <Box sx={stickerCardContainerStyle}>
          {stickerCard ? <ActionStickerCard {...stickerCard} /> : <ImageCard {...imageCard} />}
        </Box>
      </Box>
    </BaseNugget>
  );
};

const stickerCardContainerStyle: SxProps<Theme> = ({ backrs }) => ({
  width: '100%',
  paddingY: backrs.spacing['spacing-md'],
  alignSelf: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  flexDirection: 'row',
});

const contentContainerStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  '@media (min-width: 1300px)': {
    flexDirection: 'row',
  },
};
